import {CircleDestination} from './circle-destination';

export class CircleDestinations {
  id?: number;
  destinations: CircleDestination = new CircleDestination(
      {
        titles: [],
        icons: [],
        urls: [],
      }
  );
  backgrounds: string[] = [];
  cssStyleImage?: string[];


  constructor(data: CircleDestinations) {
    this.id = data.id;
    this.destinations = data.destinations ?? [];
    this.backgrounds = data.backgrounds ?? [];
    this.cssStyleImage = data.cssStyleImage ?? [];
  }
}
